import { useState, useEffect } from "react";
import DatePicker from "@/components/DatePicker";
import DebtorEditor from "@/components/DebtorEditor";
import { computeRow } from "@/lib/format";
import { X } from "lucide-react";

export default function CariForm({ initial, fixedMusteri, onClose, onSubmit }) {
  const [form, setForm] = useState({ musteri: fixedMusteri || "", tc_no: "", tutar: "", alis_fiyati: "", satis_fiyati: "", vade_tarihi: "", aciklama: "", borclular: [] });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (initial) {
      setForm({
        musteri: initial.musteri || "",
        tutar: initial.tutar ?? "",
        alis_fiyati: initial.alis_fiyati ?? "",
        satis_fiyati: initial.satis_fiyati ?? "",
        vade_tarihi: (initial.vade_tarihi || "").slice(0, 10),
        aciklama: initial.aciklama || "",
        tc_no: initial.tc_no || "",
        borclular: initial.borclular || [],
      });
    }
  }, [initial]);

  const change = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await onSubmit({
        musteri: form.musteri,
        tc_no: form.tc_no || "",
        tutar: Number(form.tutar) || 0,
        alis_fiyati: Number(form.alis_fiyati) || 0,
        satis_fiyati: Number(form.satis_fiyati) || 0,
        vade_tarihi: form.vade_tarihi || null,
        aciklama: form.aciklama,
        borclular: (form.borclular || []).filter((b) => (b.ad || "").trim()).map((b) => ({ ad: b.ad, tc: b.tc || "" })),
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-start justify-center bg-black/40 p-4 overflow-y-auto">
      <div className="bg-white border border-[#E7DECC] rounded-sm w-full max-w-lg my-16" data-testid="cari-form">
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#E7DECC]">
          <h3 className="font-heading text-xl font-bold tracking-tight">
            {initial ? "Cari Kaydı Düzenle" : fixedMusteri ? "Yeni Vade Ekle" : "Yeni Cari Müşteri"}
          </h3>
          <button onClick={onClose} aria-label="Kapat" data-testid="cari-form-close" className="text-[#8C8377] hover:text-[#26231E]">
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={submit} className="p-6">
          <label className="kicker block mb-1.5">MÜŞTERİ</label>
          <input
            value={form.musteri}
            onChange={(e) => change("musteri", e.target.value)}
            required
            readOnly={!!fixedMusteri}
            data-testid="cari-musteri-input"
            className={`w-full px-3 py-2 border border-[#E7DECC] rounded-sm mb-4 focus:outline-none focus:border-[#B8933F] ${fixedMusteri ? "bg-[#EFE7D6] text-[#8C8377] cursor-not-allowed" : ""}`}
            placeholder="Müşteri / Cari adı"
          />

          <div className="grid grid-cols-2 gap-4 mb-4">
            <div>
              <label className="kicker block mb-1.5">TC KİMLİK NO</label>
              <input
                value={form.tc_no}
                onChange={(e) => change("tc_no", e.target.value.replace(/\D/g, "").slice(0, 11))}
                inputMode="numeric"
                maxLength={11}
                data-testid="cari-tc-no-input"
                className="w-full px-3 py-2 border border-[#E7DECC] rounded-sm tabular-nums focus:outline-none focus:border-[#B8933F]"
                placeholder="Risk eşleştirme (ops.)"
              />
            </div>
            <div>
              <label className="kicker block mb-1.5">BORÇ / ALACAK TUTARI</label>
              <input
                type="number"
                step="0.01"
                value={form.tutar}
                onChange={(e) => change("tutar", e.target.value)}
                data-testid="cari-tutar-input"
                className="w-full px-3 py-2 border border-[#E7DECC] rounded-sm tabular-nums focus:outline-none focus:border-[#B8933F]"
                placeholder="0"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 mb-4">
            <div>
              <label className="kicker block mb-1.5">VADE TARİHİ</label>
              <DatePicker value={form.vade_tarihi} onChange={(v) => change("vade_tarihi", v)} testId="cari-vade-input" />
            </div>
          </div>

          <label className="kicker block mb-1.5">AÇIKLAMA</label>
          <input
            value={form.aciklama}
            onChange={(e) => change("aciklama", e.target.value)}
            data-testid="cari-aciklama-input"
            className="w-full px-3 py-2 border border-[#E7DECC] rounded-sm mb-4 focus:outline-none focus:border-[#B8933F]"
            placeholder="İsteğe bağlı not"
          />

          <div className="border border-[#E7DECC] rounded-sm p-3 mb-6">
            <DebtorEditor borclular={form.borclular} onChange={(list) => change("borclular", list)} />
          </div>

          <div className="flex justify-end gap-3">
            <button type="button" onClick={onClose} data-testid="cari-form-cancel" className="px-4 py-2 border border-[#E7DECC] rounded-sm text-sm font-medium hover:bg-[#EFE7D6] transition-colors duration-150">
              İptal
            </button>
            <button type="submit" disabled={saving} data-testid="cari-form-save" className="px-6 py-2 bg-[#B8933F] hover:bg-[#9C7A33] text-white rounded-sm text-sm font-medium transition-colors duration-150 disabled:opacity-60">
              {saving ? "Kaydediliyor..." : "Kaydet"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
